<template>
  <send-message-form
    :receivers="receivers"
    :profiles="computedProfiles"
    :teams="teams"
    :submitting="submitting"
    :state="state"
    @submit="onSendMessage"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import SendMessageForm from '@/components/forms/SendMessageForm.vue'

export default {
  name: 'SendMessage',

  props: {
    receivers: {
      type: Array,
      default: () => ([])
    }
  },

  computed: {
    ...mapGetters([
      'profileMe',
      'profiles',
      'teams'
    ]),

    computedProfiles() {
      return this.receivers.length
        ? []
        : Object.values(this.profiles).filter(p => p.id !== this.profileMe.id)
    }
  },

  data() {
    return {
      submitting: false,
      state: {}
    }
  },

  methods: {
    onSendMessage(data) {
      this.$store.dispatch('sendMessage', data)
        .then(() => this.$emit('submitted'))
        .catch(errors => { this.state = errors })
        .finally(() => { this.submitting = false })
    }
  },

  components: {
    SendMessageForm
  }
}
</script>
